import { Head, useForm } from '@inertiajs/react';
import AppLayout from '@/Layouts/AppLayout';
import Card, { CardBody } from '@/Components/Card';
import Button from '@/Components/Button';
import FormInput from '@/Components/FormInput';
import FormTextarea from '@/Components/FormTextarea';
import PageHeader from '@/Components/PageHeader';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function Edit({ role, permissions, rolePermissions }) {
    const { data, setData, put, processing, errors } = useForm({
        name: role.name || '',
        description: role.description || '',
        permissions: rolePermissions || [],
    });
    const submit = (e) => { e.preventDefault(); put(`/roles/${role.id}`); };

    const togglePermission = (id) => {
        const current = data.permissions;
        setData('permissions', current.includes(id) ? current.filter(p => p !== id) : [...current, id]);
    };

    // Group permissions by their group field
    const grouped = {};
    (Array.isArray(permissions) ? permissions : []).forEach(p => {
        const group = p.group || 'general';
        if (!grouped[group]) grouped[group] = [];
        grouped[group].push(p);
    });

    return (
        <AppLayout>
            <Head title="Edit Role" />
            <PageHeader title="Edit Role" subtitle={`Editing ${role.name}`} actions={<Button href="/roles" variant="outline" size="sm"><ArrowLeftIcon className="w-4 h-4" /> Back</Button>} />
            <form onSubmit={submit}>
                <Card className="mb-6">
                    <CardBody className="space-y-4 max-w-lg">
                        <FormInput label="Role Name" value={data.name} onChange={e => setData('name', e.target.value)} error={errors.name} required />
                        <FormTextarea label="Description" value={data.description} onChange={e => setData('description', e.target.value)} rows={3} />
                    </CardBody>
                </Card>
                <Card>
                    <div className="px-6 py-4 border-b border-slate-100"><h3 className="font-semibold text-slate-800">Permissions</h3></div>
                    <CardBody>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {Object.entries(grouped).map(([group, perms]) => (
                                <div key={group} className="p-4 rounded-xl border border-slate-200 bg-slate-50/50">
                                    <h4 className="font-semibold text-sm text-slate-700 capitalize mb-3">{group}</h4>
                                    <div className="space-y-2">
                                        {perms.map(perm => (
                                            <label key={perm.id} className="flex items-center gap-2 cursor-pointer">
                                                <input type="checkbox" checked={data.permissions.includes(perm.id)} onChange={() => togglePermission(perm.id)} className="w-4 h-4 rounded border-slate-300 text-emerald-700 focus:ring-emerald-700" />
                                                <span className="text-sm text-slate-600">{perm.name}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>
                <div className="flex gap-3 mt-6">
                    <Button type="submit" disabled={processing}>Save Changes</Button>
                    <Button href="/roles" variant="outline">Cancel</Button>
                </div>
            </form>
        </AppLayout>
    );
}
